/* eslint-disable */
/* tslint:disable */

import { DownOutlined } from '@ant-design/icons'
import { Button, Dropdown, Layout, Menu, message } from 'antd'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import Login from '../../features/user/login/login'
import { getEnv } from '../../helpers/mobx-easy-wrapper'
import clickBtn from '../../images/click_btn.png'
import headerLogo from '../../images/headerLogo.png'
import userLogin from '../../images/user.svg'
import { isNumber } from '../../utils/NumberUtil'
import Dialog from '../dialog/dialog'

const Header = () => {
  const [logined, setLogined] = useState(false)
  const [user, setUser] = useState()
  const [showLogin, setShowLogin] = useState(false)
  const [enter, setEnter] = useState('enterprise')

  const { apiFactory } = getEnv()
  useEffect(() => {
    const loginFlag = apiFactory.authService.isAuthenticated()
    if (loginFlag) {
      const user = apiFactory.authService.getLoginUser()
      setUser(user)
    }
    async function getDetail() {
      const result = await apiFactory.activityService.getWorksDetail()

      if (result && result.type === '高校') {
        setEnter('college')
        ;(window as any)['enter'] = 'college'
      }

      if (result && isNumber(result.status)) {
        ;(window as any)['enterStatus'] = result.status
      }
    }
    getDetail()
    setLogined(loginFlag)

    baiduStatistics()
    function baiduStatistics() {
      // 百度统计
      var _hmt = _hmt || []
      ;(function () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?57dc2f56f3aada3d1fd6ddfb66ca4e37'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }
  }, [])

  const logout = () => {
    apiFactory.authService.logout()
    message.success('注销成功')
    setTimeout(() => {
      window.location.reload()
    }, 600)
  }

  // @ts-ignore
  const menu = (
    <Menu>
      <Menu.Item key="1">
        <label>注销</label>
      </Menu.Item>
      {/*        <Menu.SubMenu key="SubMenu" title="Navigation Three - Submenu" icon={<SettingOutlined />}>
          <Menu.ItemGroup title="Item 1">
            <Menu.Item key="app" icon={<AppstoreOutlined />}>
              Navigation Two
            </Menu.Item>
            <Menu.Item key="disabled" disabled>
              Navigation Three
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu.SubMenu>*/}
    </Menu>
  )

  const MenuItems = (
    <Menu>
      <Menu.Item>
        <a href="https://2023.ipop.sh.cn/" target="_blank">
          2023年回顾
        </a>
      </Menu.Item>
      <Menu.Item>
        <a href="https://2022.ipop.sh.cn/" target="_blank">
          2022年回顾
        </a>
      </Menu.Item>
    </Menu>
  )

  return (
    <Layout.Header
      className="header App"
      onMouseLeave={() => {
        ;(document.querySelector('.header') as HTMLDivElement).classList.remove(
          'leave'
        )
        ;(
          document.querySelector('.header') as HTMLDivElement
        ).style.removeProperty('transform')
      }}>
      <ul className="container">
        <li>
          {' '}
          <img
            className="logo"
            src={headerLogo}
            style={{
              width: '350px',
              height: 'auto',
              float: 'left',
              marginRight: '35px',
            }}
          />{' '}
        </li>
        <li style={{ margin: '0 auto' }}>
          <ul className="dropdown">
            <li onClick={() => (location.href = '/')}>首页</li>
            <li onClick={() => (location.href = '/require')}>参赛要求</li>
            <li onClick={() => (location.href = '/schedule')}>赛程及奖项</li>
            {/* <li onClick={() => (location.href = "/org")}>大赛组织</li> */}
            {/* <li onClick={() => (location.href = '/jury')}>大赛评委</li> */}

            <li onClick={() => (location.href = '/trends')}>大赛动态</li>
            {/* <li onClick={() => (location.href = `/enter/${enter}`)}>马上报名</li> */}
            {/* <li>
              <Dropdown overlay={MenuItems}>
                <span>
                  往届回顾
                  <DownOutlined
                    style={{ marginLeft: '7px', fontSize: '14px' }}
                  />
                </span>
              </Dropdown>
            </li> */}
          </ul>
        </li>

        <li className="container__item--right">
          {/* <div className="apply_btn"> */}
          <Button
            className="apply_btn"
            type="primary"
            shape="round"
            onClick={() => (location.href = `/enter/${enter}`)}>
            马上报名 <img src={clickBtn} alt="" />
          </Button>
          {/* </div> */}
          <div
            id="loginHeader"
            className="user"
            onClick={() => {
              !logined && setShowLogin(true)
            }}>
            {/* <div className={`${logined ? 'dropdown' : ''}`}> */}
            <div className={`dropdown`}>
              <img src={userLogin} />
              {logined ? (
                <>
                  <label>{user && (user! as any).name}</label>
                  <div className="dropdown__content">
                    <div
                      className="logout"
                      style={{ marginTop: '8px' }}
                      onClick={logout}>
                      注销
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <label>用户登录</label>
                </>
              )}
            </div>
          </div>
        </li>
      </ul>

      {showLogin && (
        <Dialog>
          <Login
            closeEvent={() => {
              setShowLogin(false)
            }}
          />
        </Dialog>
      )}
    </Layout.Header>
  )
}

export default observer(Header)
